import { getApiClient } from '../../services/apiClient'
import { closedAreaContent } from './content'

export const getUserData = async (data: any, getToken: () => string) => {
  const roles = []

  if (data.profile.fanclub_status === '002') {
    roles.push(closedAreaContent.user.roles.api.member)
  }

  let memberId = null
  let representative = undefined

  const apiClient = getApiClient(data.access_token)
  try {
    const memberInfo = await apiClient.getMember()
    if (memberInfo) {
      if (memberInfo.id > 0) {
        memberId = memberInfo.id
      }
      if (memberInfo.representative) {
        roles.push(closedAreaContent.user.roles.api.representative)
        representative = await apiClient.getRepresentative({ id: memberId })
      }
    }
  } catch (error) {
    console.error('Ignore error while fetching member info', error)
  }

  return {
    id: memberId,
    firstname: data.profile.given_name,
    lastname: data.profile.family_name,
    name: data.profile.name,
    email: data.profile.email,
    region: data.profile.region,
    getToken,
    roles,
    representative,
  }
}

export const USER_ACTIONS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
}
